import React, { FC, useEffect, useState } from 'react';
import { Radio, CheckboxOptionType, RadioChangeEvent } from 'antd';

interface RadioComponentProps {
  name: string;
  value?: string | number;
  options: CheckboxOptionType[];
  onChange: (value: string | number) => void;
  disabled?: boolean;
  radioCancleChoose?: () => void;
}

const RadioComponent: FC<RadioComponentProps> = (props) => {
  const {
    value: initialValue,
    options,
    onChange,
    disabled,
    radioCancleChoose,
  } = props;
  const [value, setValue] = useState<string | number | undefined>(initialValue);

  const handleChange = (e: RadioChangeEvent) => {
    const newValue = e.target.value;
    onChange(newValue);
  };
  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);
  return (
    <div className='radio-component'>
      <Radio.Group value={value} onChange={handleChange} disabled={disabled}>
        {options?.map((option) => (
          <Radio
            key={option.value as string}
            value={option.value}
            onClick={radioCancleChoose}
          >
            {option.label}
          </Radio>
        ))}
      </Radio.Group>
    </div>
  );
};

export default RadioComponent;
